import { Action, State, StateContext } from '@ngxs/store';
import {
  ClearOrderWorkflow,
  OpenChat,
  PatchOrder,
  SetExternalAuthStatus,
  SetOrder,
  SetOrderProduct,
  SetProductType,
} from '@features/client/order-workflow/state/order-workflow.actions';
import { Injectable } from '@angular/core';
import { OrderWorkflowStateModel } from '@features/client/order-workflow/state/order-workflow-state.model';

@State<OrderWorkflowStateModel>({
  name: 'orderWorkflow',
  defaults: {
    order: null,
    unsavedOrder: null,
    unsavedOrderId: null,
    productType: null,
    orderProduct: null,
    openChat: false,
    externalAuthStatus: [],
  },
})
@Injectable()
export class OrderWorkflowState {
  @Action(SetOrder)
  public setOrder(ctx: StateContext<OrderWorkflowStateModel>, { order, options }: SetOrder): void {
    const { order: currentOrder, unsavedOrderId } = ctx.getState();
    const isOtherOrder = (currentOrder?.id ?? null) !== (order?.id ?? null);

    // A save or fetch response can arrive after another order was opened.
    if (isOtherOrder && !options?.switchOrder) {
      return;
    }

    if (currentOrder?.id && isOtherOrder) {
      ctx.patchState({ order, unsavedOrder: null, unsavedOrderId: null });

      return;
    }

    ctx.patchState({ order, unsavedOrderId: unsavedOrderId ?? order?.id ?? null });
  }

  @Action(SetProductType)
  public setProductType(ctx: StateContext<OrderWorkflowStateModel>, { productType }: SetProductType): void {
    ctx.patchState({ productType });
  }

  @Action(SetOrderProduct)
  public setOrderProduct(ctx: StateContext<OrderWorkflowStateModel>, { orderProduct }: SetOrderProduct): void {
    ctx.patchState({ orderProduct });
  }

  @Action(ClearOrderWorkflow)
  public clearOrderWorkflow(ctx: StateContext<OrderWorkflowStateModel>): void {
    ctx.setState({} as any);
  }

  @Action(PatchOrder)
  public patchOrder(ctx: StateContext<OrderWorkflowStateModel>, { unsavedOrder }: PatchOrder): void {
    // A save response can arrive after another order was opened, so it keeps its own id.
    ctx.patchState({ unsavedOrder, unsavedOrderId: unsavedOrder?.id ?? ctx.getState().order?.id ?? null });
  }

  @Action(OpenChat)
  public openChat(ctx: StateContext<OrderWorkflowStateModel>, action: OpenChat): void {
    ctx.patchState({ openChat: action.openChat });
  }

  @Action(SetExternalAuthStatus)
  public setExternalAuthStatus(
    ctx: StateContext<OrderWorkflowStateModel>,
    { externalAuthStatus }: SetExternalAuthStatus,
  ): void {
    ctx.patchState({ externalAuthStatus });
  }
}
